<template>
  <b-modal
    ref="modal"
    title="Dodawanie rezerwacji"
    centered
    no-close-on-backdrop
    @show="form.reset()"
  >
    <Errors />

    <b-table-simple v-if="item && event" small borderless>
      <b-tbody>
        <b-tr>
          <b-td>Termin:</b-td>
          <b-th>{{ item.date_string }}</b-th>
        </b-tr>
        <b-tr>
          <b-td>Czas:</b-td>
          <b-th>{{ item.duration }} min</b-th>
        </b-tr>
        <b-tr>
          <b-td>Fryzjer:</b-td>
          <b-th>{{ event.barber.name }}</b-th>
        </b-tr>
        <b-tr>
          <b-td>Rodzaj:</b-td>
          <b-th>
            <span class="text-primary">
              telefonicznie
            </span>
          </b-th>
        </b-tr>
      </b-tbody>
    </b-table-simple>

    <b-form ref="form" @submit.prevent="submit">
      <b-form-group label="Usługa">
        <b-form-select
          v-model="form.serviceId"
          :state="Boolean(form.serviceId)"
          :options="select_services"
          :disabled="form.processing"
          required
        />
      </b-form-group>

      <b-form-group v-if="hasContactsAccess" label="Kontakt">
        <b-form-select
          v-model="selectedContactId"
          :options="contactsOptions"
          :disabled="form.processing"
          @change="updateContactDetails"
        />
      </b-form-group>

      <b-form-group label="Telefon">
        <b-input
          v-model="form.phoneNumber"
          :state="isPhoneValid"
          :formatter="phoneFormatter"
          :disabled="form.processing"
          type="tel"
          required
        />
      </b-form-group>
      <b-form-group label="Email" class="mb-0">
        <b-input
          v-model="form.email"
          :state="isEmailValid"
          :disabled="form.processing"
          type="email"
        />
      </b-form-group>
    </b-form>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <div>
          <b-button variant="secondary" @click="hide('forget')">
            Anuluj
          </b-button>
        </div>
        <div>
          <b-button
            variant="primary"
            :disabled="form.processing"
            @click="submit"
          >
            <span v-if="form.processing">
              <b-spinner small />
            </span>
            Dodaj rezerwację
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Errors from '@/Layouts/Components/Errors'
import EmailValidation from '@/Mixins/EmailValidation'

export default {
  components: {
    Errors,
  },
  mixins: [EmailValidation],
  props: {
    services: Array,
    item: Object,
    event: Object,
    contacts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: this.$inertia.form({
        dateString: '',
        barberId: 0,
        byPhone: true,
        phoneNumber: '',
        serviceId: 0,
        email: '',
      }),
      selectedContactId: null,
    }
  },
  computed: {
    isPhoneValid() {
      const phone = this.form.phoneNumber.replace(/ /g,'')
      return phone.length === 9
    },
    isEmailValid() {
      return this.validateEmail(this.form.email);
    },
    select_services() {
      return this.services.map((service) => {
        return {
          value: service.id,
          text: service.name,
        }
      })
    },
    hasContactsAccess() {
      return this.contacts && this.contacts.length > 0
    },
    contactsOptions() {
      return this.contacts.map((contact) => {
        return {
          value: contact.id,
          text: contact.name
        }
      })
    }
  },
  methods: {
    submit() {
      if (!this.$refs.form.checkValidity()) return;

      this.form.dateString = this.event.date_string
      this.form.barberId = this.event.barber.id

      this.form.post(this.route('reservations.store'), {
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => this.hide()
      })
    },
    phoneFormatter(val) {
      val = val.replace(/\D/g,'').match(/.{1,3}/g) || []
      return val.join(' ')
    },
    updateContactDetails() {
      if (!this.selectedContactId) return;
      const selectedContact = this.contacts.find(contact => contact.id === this.selectedContactId)
      if (selectedContact) {
        this.form.phoneNumber = selectedContact.phone_number
        if (selectedContact.email) {
          this.form.email = selectedContact.email
        }
      }
    },
    show() {
      this.form.reset()
      this.selectedContactId = null
      this.$refs.modal.show()
    },
    hide() {
      this.form.reset()
      this.selectedContactId = null
      this.$refs.modal.hide()
    },
  },
}
</script>
